import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';


@Component
class ErrorDialog extends Vue {

    @Prop({ default: null, type: [Error, Object] })
    error: any

    readonly dtIsOpen: boolean = true;

    get lblSetting() {
        return {
            ...require('@/locales/button').default,
            ...require('@/locales/generic-labels').default
        }
    }

    handleClose(){
        this.$emit('cancel')
    }
}


export default ErrorDialog


// WEBPACK FOOTER //
// ./src/components/error-dialog/index.ts